const actionPrefix = (actionType) => `EnvConfig/${actionType}`;

export const SET_ENV_CONFIG = actionPrefix`SET_ENV_CONFIG`;
export const setEnvConfig = (envConfig) => ({
  type: SET_ENV_CONFIG,
  payload: envConfig,
});

export const envConfigActions = {
  setEnvConfig,
};
